import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Sparkles, DollarSign, TrendingUp, MessageSquare, FileText } from 'lucide-react';
export function AskAnything() {
  const queries = [{
    q: 'Hey MR, how much am I paying per lead?',
    a: "You're currently paying $42.50 per lead across Google Ads and Meta. This is down 12% from last week.",
    source: 'Google Ads & Meta'
  }, {
    q: "Hey MR, what's my close rate this month?",
    a: "Your close rate for October is 28.4%. You've closed 14 out of 49 qualified opportunities.",
    source: 'CRM Data'
  }, {
    q: "Hey MR, did Miller's respond?",
    a: "Yes, John Miller replied 2 hours ago asking for the updated contract. I've drafted the response and attached the PDF for your review.",
    source: 'Email Inbox'
  }, {
    q: 'Hey MR, write a follow-up for the Johnson proposal.',
    a: "Done. I've sent a polite follow-up to Sarah Johnson referencing the key ROI metrics we discussed on Tuesday.",
    source: 'Action Executed'
  }];
  return <>
      {/* Gradient Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-purple/20 to-transparent" data-id="element-81" />

      <section className="section-padding bg-dark-bg relative overflow-hidden" data-id="element-82">
        {/* Subtle Ambient Glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-purple/5 rounded-full blur-[150px] opacity-30 pointer-events-none" data-id="element-83" />

        <div className="inner-container relative z-10" data-id="element-84">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-85">
            <span className="text-purple text-sm font-poppins font-bold uppercase tracking-widest" data-id="element-86">
              Ask Anything
            </span>
            <h2 className="font-poppins font-extrabold text-4xl md:text-5xl leading-tight mt-4 text-white" data-id="element-87">
              Hey MISTR — Just Ask.
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-88">
            {queries.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.15
          }} className="bg-white/5 border border-white/10 rounded-2xl p-6 flex flex-col gap-4 shadow-sm" data-id="element-89">
                {/* Question Bubble */}
                <div className="bg-white/10 rounded-2xl rounded-tr-sm p-4 self-end max-w-[85%] border border-white/10" data-id="element-90">
                  <p className="font-inter text-sm md:text-base text-white" data-id="element-91">
                    "{item.q}"
                  </p>
                </div>

                {/* Answer Bubble */}
                <div className="bg-purple/5 border border-purple/20 rounded-2xl rounded-tl-sm p-4 self-start max-w-[90%] relative" data-id="element-92">
                  <div className="absolute -top-3 -left-3 bg-purple rounded-full p-1.5 shadow-[0_0_15px_rgba(124,58,237,0.4)]" data-id="element-93">
                    <Sparkles size={14} className="text-white" data-id="element-94" />
                  </div>
                  <p className="font-inter text-sm md:text-base text-steel leading-relaxed" data-id="element-95">
                    {item.a}
                  </p>
                  <div className="mt-3 pt-3 border-t border-purple/10 flex items-center gap-2" data-id="element-96">
                    <span className="text-xs font-poppins text-purple uppercase tracking-wider font-semibold" data-id="element-97">
                      Source: {item.source}
                    </span>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </>;
}